import { Button } from '@shigo-ui/ui';

import type { TargetingLocation } from '../../model';
import { dashboardT } from '../../../../lib/messages';
import { SelectedGeoList } from './SelectedGeoList';

type GeolocationSelectionPanelProps = {
  locations: TargetingLocation[];
  onClear: () => void;
  onRemove: (location: TargetingLocation) => void;
};

export function GeolocationSelectionPanel({
  locations,
  onClear,
  onRemove,
}: GeolocationSelectionPanelProps) {
  const includedLocations = locations.filter((location) => !location.excluded);
  const excludedLocations = locations.filter((location) => location.excluded);

  return (
    <div className="bg-background/30 grid content-start">
      <div className="border-border flex items-center justify-between gap-3 border-b px-3 py-3">
        <span className="text-foreground text-sm font-semibold">
          {dashboardT('targeting.selected', { count: String(locations.length) })}
        </span>
        <Button
          type="button"
          variant="ghost"
          className="h-6 px-1.5 text-[11px] font-semibold tracking-wide uppercase"
          disabled={!locations.length}
          onClick={onClear}
        >
          {dashboardT('madBuy.common.clear')}
        </Button>
      </div>
      <SelectedGeoList
        excluded={false}
        locations={includedLocations}
        onRemove={onRemove}
        title={dashboardT('targeting.include')}
      />
      <SelectedGeoList
        excluded
        locations={excludedLocations}
        onRemove={onRemove}
        title={dashboardT('targeting.exclude')}
      />
    </div>
  );
}
